import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, SparklesIcon, StarIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE_FULL, PRICE_SHORT, Section, trackCheckoutClick } from './Shared';
import { Blossom, DropperBottle } from './Decor';
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 54,
    s: 25
  });
  const spotsTaken = 78;
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(current => {
      const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
      return {
        h: Math.floor(seconds / 3600),
        m: Math.floor(seconds % 3600 / 60),
        s: seconds % 60
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-173" data-mp="2kc3m7qoxfmnk">
      <div className="min-w-[58px] rounded-xl bg-brand-taupe px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-goldLight ring-1 ring-brand-gold/40 md:min-w-[80px] md:px-5 md:py-3 md:text-4xl" data-id="element-174" data-mp="12sj30upx9v7w">
        {format(value)}
      </div>
      <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-brand-muted md:text-sm" data-id="element-175" data-mp="1cj5goje2wbny">
        {label}
      </span>
    </div>;
  return <div className="mx-auto mb-12 max-w-4xl" data-id="element-176" data-mp="1meff6x59q0wz">
      <div className="paper-panel rounded-3xl border-2 border-brand-gold/45 p-6 md:p-8" data-id="element-177" data-mp="1mhbhexo5fbr8">
        <div className="mb-5 flex items-center justify-center gap-2" data-id="element-178" data-mp="1hii16xhh96nd">
          <ClockIcon className="h-5 w-5 text-brand-goldDark" data-id="element-179" data-mp="1vevgq12gaxz7" />
          <h3 className="font-serif text-base font-bold text-brand-taupe md:text-xl" data-id="element-180" data-mp="1qgkas1fa17m9">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>
        <div className="mb-5 flex items-center justify-center gap-2 md:gap-4" data-id="element-181" data-mp="148es8wsprz6">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-182" data-mp="3sa03r4yu6yke" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-183" data-mp="1w5ty5bzezfof">:</span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-184" data-mp="214dm1hxkj1jf" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-185" data-mp="2156jttejugpf">:</span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-186" data-mp="2638ezcp926h9" />
        </div>
        <div className="mb-6 flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-brand-goldLight/50 px-4 py-3" data-id="element-187" data-mp="265ukz7whsdxd">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-brand-goldDark" data-id="element-188" data-mp="2f4y246c3mj98" />
          <p className="text-center text-sm font-semibold text-brand-text md:text-base" data-id="element-189" data-mp="2k2pwd707uhgl">
            Después sube. <span className="text-brand-sageMid" data-id="element-190" data-mp="2otg2wnkdoqcv">No vuelve.</span>
          </p>
        </div>
        <div className="rounded-2xl border border-brand-taupe/15 bg-white p-4 md:p-5" data-id="element-191" data-mp="2tssvzq1uetnw">
          <div className="mb-3 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" data-id="element-192" data-mp="2xuo1l6qt3t7h">
            <span className="flex items-center gap-2 text-sm font-semibold text-brand-text md:text-base" data-id="element-193" data-mp="32tqvpw590f0o">
              <span className="relative flex h-2.5 w-2.5" data-id="element-194" data-mp="r65kbxpc1o5p">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-gold opacity-75" data-id="element-195" data-mp="r7ovj9w4t90m" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-brand-gold" data-id="element-196" data-mp="i5pg2m0rmczs" />
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold uppercase tracking-wide text-brand-rose" data-id="element-197" data-mp="d8paec7tvc97">Quedan pocos</span>
          </div>
          <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-brand-taupe/10" data-id="element-198" data-mp="15v9z14wx5a92">
            <div className="h-full rounded-full bg-brand-sageMid" style={{
            width: `${spotsTaken}%`
          }} data-id="element-199" data-mp="15xnwfkf2myjs" />
          </div>
          <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-200" data-mp="w4fdy3vesgp7">
            <strong className="text-brand-sageMid" data-id="element-201" data-mp="1tkm9s97w9qdh">{spotsTaken}%</strong> de los cupos al precio de lanzamiento ya
            tomados
          </p>
        </div>
      </div>
    </div>;
}
function Pricing() {
  return <Section id="comprar" glow className="my-12 rounded-3xl border-2 border-brand-gold/50 bg-brand-parchment" data-id="element-202" data-mp="18e52seul0uwx">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-3xl" data-id="element-203" data-mp="1dess8w35x3p1">
        <Blossom className="absolute left-6 top-8 h-20 w-20 text-brand-roseMist" data-id="element-204" data-mp="zf9umx7z9aqz" />
        <DropperBottle className="absolute bottom-6 right-8 hidden h-32 w-16 text-brand-sageMist md:block" data-id="element-205" data-mp="14e2zk1977tfj" />
      </div>

      <div className="relative mb-10 text-center" data-id="element-206" data-mp="1s35rq31gl4oa">
        <span className="animate-glow-pulse mb-4 inline-flex items-center gap-2 rounded-full bg-brand-taupe px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-goldLight md:text-sm" data-id="element-207" data-mp="1w3zdoqvcc9ej">
          🌸 Oferta de lanzamiento
        </span>
        <h2 className="font-serif text-3xl font-bold text-brand-taupe md:text-4xl" data-id="element-208" data-mp="1nacmle22vubo">
          TU <span className="text-brand-goldDark" data-id="element-209" data-mp="2b0q6uief8ovp">GUÍA DEFINITIVA DE COSMÉTICA NATURAL</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-brand-sageMid md:text-base" data-id="element-210" data-mp="2ftrmwtqd6ugv">
          El precio de lanzamiento vence hoy. Después sube. No vuelve.
        </p>
      </div>

      <div className="mx-auto max-w-2xl space-y-5" data-id="element-211" data-mp="2l683zxzifopo">
        <div className="relative rounded-3xl" data-id="element-212" data-mp="2l3lzk77x1pbo">
          <span className="glow-frame" aria-hidden="true" data-id="element-213" data-mp="2yvs3muxso5ur" />
          <div className="relative z-10 rounded-3xl bg-white p-6 shadow-lg md:p-8" data-id="element-214" data-mp="2txqlqdc3uckv">
            <div className="mb-3 flex items-center gap-1.5 text-brand-goldDark" data-id="element-215" data-mp="2tztjjjji1a05">
              <SparklesIcon className="h-4 w-4" data-id="element-216" data-mp="268fubmgn9uje" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-217" data-mp="2272m55q2xf9b" />
              <span className="text-[10px] font-bold uppercase tracking-wider md:text-sm" data-id="element-218" data-mp="228nin0vyf89t">
                El kit argentino más completo
              </span>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-219" data-mp="2b6h8bsz7r3o0">
              <div className="max-w-md" data-id="element-220" data-mp="3rkpjkrej9qkc">
                <h3 className="font-serif text-lg font-bold text-brand-taupe md:text-xl" data-id="element-221" data-mp="3rnlkmologvd0">
                  🌿 COSMÉTICA NATURAL — LA GUÍA DEFINITIVA
                </h3>
                <p className="mt-1 text-sm text-brand-muted" data-id="element-222" data-mp="3umbxjd74y66o">3 Tomos + 6 Bonus · Más de 300 páginas</p>
                <p className="mt-2 text-sm font-medium leading-relaxed text-brand-sageMid" data-id="element-223" data-mp="2hzxawaki9ib">
                  Recetarios, alquimia vibracional, ingeniería de precios, branding magnético y guiones de venta.
                  Acceso de por vida con actualizaciones futuras incluidas.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-224" data-mp="3b0xomrcvdez0">
                <p className="text-xs uppercase tracking-wide text-brand-muted" data-id="element-225" data-mp="3fxfujujxrjcx">Valor original</p>
                <p className="text-lg text-brand-muted line-through" data-id="element-226" data-mp="3kx0ry0jgjjnj">{PRICE_FULL}</p>
                <p className="mt-1 text-xs uppercase tracking-wide text-brand-muted" data-id="element-227" data-mp="3pnr0fmn6k2mg">Precio de lanzamiento</p>
                <p className="font-serif text-4xl font-bold text-brand-taupe md:text-5xl" data-id="element-228" data-mp="2s94w0y1ppvrt">{PRICE_SHORT}</p>
                <p className="text-xs text-brand-muted" data-id="element-229" data-mp="2x6y2ztauatt5">Acceso inmediato de por vida</p>
              </div>
            </div>
          </div>
        </div>

        <motion.a href={CHECKOUT_URL} onClick={trackCheckoutClick} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} className="cta-shimmer relative flex w-full justify-center overflow-hidden rounded-full bg-brand-taupe px-6 py-5 text-center text-base font-bold text-brand-cream shadow-[0_12px_28px_rgba(94,74,52,.26)] ring-1 ring-brand-gold/50 md:text-xl" data-id="element-230" data-mp="2plujzhwiipfb">
          <span className="relative z-10" data-id="element-231" data-mp="21x1lpesf45hj">QUIERO MI PACK AHORA {PRICE_SHORT} →</span>
        </motion.a>

        <div className="grid gap-3 rounded-2xl bg-brand-sageMist p-4 text-center sm:grid-cols-4" data-id="element-232" data-mp="1wzszn345fhb0">
          {['✓ Acceso inmediato', '✓ 100% PDF', '✓ Garantía 7 días', '✓ Pago seguro'].map(item => <span key={item} className="text-xs font-bold text-brand-sageMid" data-id="element-233" data-mp="1n02736z5fcdk">
              {item}
            </span>)}
        </div>
      </div>
    </Section>;
}
export function LaunchOffer() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-234" data-mp="36xrddxe6rhfc">
      <LaunchUrgency data-id="element-235" data-mp="3bw2n884hdrxk" />
      <Pricing data-id="element-236" data-mp="3buhqqcylvyx2" />
    </div>;
}